"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const utils_common_to_kebap_case_1 = __importDefault(require("@gcloud-npm/utils.common.to-kebap-case"));
const mocks_json_1 = __importDefault(require("./mocks.json"));
/**
 * normalizador del modulo MODULO_TELETIPO
 * @param {object} fields
 * @returns
 */
const teletipoNormalizer = (data, userCompatibilities, productCompatibilityGroup) => {
    var _a;
    try {
        const res = {};
        const { fields } = data;
        if (fields) {
            const { backgroundColor, icon, iconColor, subTitle, buttonText, href } = fields;
            let { title } = fields;
            let faProductName = "";
            if (userCompatibilities && productCompatibilityGroup) {
                const productCompatibilities = userCompatibilities[productCompatibilityGroup];
                if (productCompatibilities) {
                    faProductName = ((_a = productCompatibilities === null || productCompatibilities === void 0 ? void 0 : productCompatibilities.secondaryBundle) === null || _a === void 0 ? void 0 : _a.name) || "";
                    title = title.replace("{{nombreComercial}}", faProductName);
                }
            }
            if (buttonText && href) {
                res["Button-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Button-1"]), { href, label: buttonText });
            }
            res["Card-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Card-1"]), { backgroundColor });
            res["Text-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-1"]), { text: title });
            if (subTitle) {
                res["Text-2"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-2"]), { text: subTitle });
            }
            res["Glyph-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Glyph-1"]), { id: (0, utils_common_to_kebap_case_1.default)(icon), color: iconColor });
        }
        return res;
    }
    catch (error) {
        console.error(error);
        return null;
    }
};
exports.default = teletipoNormalizer;
//# sourceMappingURL=index.js.map